import { Model } from 'vue-models'
import TextField from './types/TextField'

export default class Carrier extends Model {
  static defaults () {
    return {
      name: 'carrier',
      basePath: 'carriers',
      computed: {
        __str__ () { return this.short_name }
      }
    }
  }
  static schema () {
    return {
      id: { type: Number },
      official_name: { type: TextField },
      short_name: { type: TextField },
      scac: { type: TextField },
      oicode: { type: TextField },
      request_type_support: { type: Object, properties: {b_id: {type: Boolean}, c_id: {type: Boolean}, m_bl: {type: Boolean}} },
      ctt_quality: { type: Object, properties: {note: {type: TextField}, rank: {type: TextField}} }
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/carrier.js